/* Tribe sizing rules, shared by the Find Your Tribe Board quiz and the product page size helper.
   Start: chin-to-knee measurement (rounded to the nearest half inch) if given, otherwise the height chart.
   Longer reasons: dropknee, beginner, soft small waves, no swimfins.
   Shorter reasons: advanced, hollow powerful waves, big waves.
   Point breaks and various waves: no change. Never more than 1" from the starting size. */
(function () {
  'use strict';
  var STD = { h1: [34, 36], h2: [36, 36], h3: [38, 38], h4: [39, 39], h5: [40, 40], h6: [40, 41], h7: [41.5, 42], h8: [42, 42.5], h9: [42.5, 43], h10: [43.5, 44.5], h11: [44.5, 46] };
  var HV = { h1: [40, 40], h2: [40, 40], h3: [40, 40], h4: [40, 40], h5: [40, 40], h6: [41, 41.5], h7: [41.5, 42], h8: [42, 42.5], h9: [42.5, 43.5], h10: [43.5, 44.5], h11: [44.5, 46] };
  var UP = {
    dk: 'you ride dropknee', pdk: 'you ride some dropknee', beg: "you're a beginner",
    small: 'you ride soft, small waves', nofins: 'you ride without swimfins'
  };
  var DOWN = { adv: "you're advanced", hollow: 'you ride hollow, powerful waves', big: 'you ride big waves' };

  function fmt(n) { return (Math.round(n * 10) / 10) + '"'; }
  function rng(r) { return fmt(r[0]) + (r[1] !== r[0] ? ' to ' + fmt(r[1]) : ''); }
  function isHV(w) { return w === 'w3' || w === 'w4' || w === 'w5'; }
  function list(a) {
    if (a.length < 2) return a.join('');
    return a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1];
  }

  /* a = { height, weight, style, level, waves, fins, ck } */
  function plan(a) {
    var hv = isHV(a.weight);
    var chart = (hv ? HV : STD)[a.height].slice();
    var m = parseFloat(a.ck);
    m = (m >= 20 && m <= 60) ? Math.round(m * 2) / 2 : null;
    var base = m != null ? [m, m] : chart.slice();
    var mismatch = m != null && (m < chart[0] - 1 || m > chart[1] + 1);
    var up = [], down = [];
    if (a.style === 'dk') up.push(UP.dk);
    if (a.style === 'pdk') up.push(UP.pdk);
    if (a.level === 'beg') up.push(UP.beg);
    if (a.waves === 'small') up.push(UP.small);
    if (a.fins === 'no') up.push(UP.nofins);
    if (a.level === 'adv') down.push(DOWN.adv);
    if (a.waves === 'hollow') down.push(DOWN.hollow);
    if (a.waves === 'big') down.push(DOWN.big);
    var net = up.length - down.length;
    var win = net > 0 ? [base[0], base[1] + 1] : net < 0 ? [base[0] - 1, base[1]] : [base[0] - 0.5, base[1] + 0.5];
    var reasons = net > 0 ? up : net < 0 ? down : [];
    var lean = '';
    if (net !== 0) {
      var txt = list(reasons);
      lean = txt.charAt(0).toUpperCase() + txt.slice(1) + ', so you can go up to 1" ' + (net > 0 ? 'longer' : 'shorter') + '.';
    } else if (up.length) {
      lean = 'Your answers balance out, so stay close to your size.';
    }
    return { hv: hv, chart: chart, measure: m, base: base, mismatch: mismatch, net: net, win: win, lean: lean, up: up, down: down };
  }

  /* sizes = [{ size, ...anything }] in stock. Returns up to 4, each tagged: mine, chart, longer, shorter. */
  function choose(sizes, p) {
    var seen = {}, out = [];
    sizes.forEach(function (s) {
      if (s.size == null) return;
      var inWin = s.size >= p.win[0] && s.size <= p.win[1];
      var inChart = p.mismatch && s.size >= p.chart[0] && s.size <= p.chart[1];
      if (!inWin && !inChart) return;
      if (!seen[s.size]) { seen[s.size] = { size: s.size, items: [] }; out.push(seen[s.size]); }
      seen[s.size].items.push(s);
    });
    var mid = (p.base[0] + p.base[1]) / 2;
    out.sort(function (x, y) { return Math.abs(x.size - mid) - Math.abs(y.size - mid); });
    out = out.slice(0, 4).sort(function (x, y) { return x.size - y.size; });
    var best = null;
    out.forEach(function (o) {
      o.tag = (o.size >= p.base[0] && o.size <= p.base[1]) ? 'mine'
        : (p.mismatch && o.size >= p.chart[0] && o.size <= p.chart[1]) ? 'chart'
        : o.size > p.base[1] ? 'longer' : 'shorter';
    });
    out.forEach(function (o) {
      if (best === null || Math.abs(o.size - mid) < Math.abs(best.size - mid) ||
        (Math.abs(o.size - mid) === Math.abs(best.size - mid) && o.tag === 'mine')) best = o;
    });
    if (best) best.best = true;
    return out;
  }

  window.TribeSizing = { STD: STD, HV: HV, plan: plan, choose: choose, fmt: fmt, rng: rng, list: list };
})();
